/**
 * How the platform shows an index-rebalance forecast's probability: "62%", or "Confirmed" for a
 * provider-confirmed change (1.0).
 *
 * The platform used to show the analysts' conviction band (High from 0.70, Medium from 0.40). Most
 * series now carry the model's calibrated probability, on which a call is 0.50 or more, so the
 * bands mislabelled them (a model call at 0.55 read "Medium"). The number is shown instead.
 *
 * An unconfirmed forecast never reads 100%: that figure would look like a confirmation, so 0.995
 * and above read 99%. Matches TED's `forecast.probability_label`, so the stock events feed and
 * the pages say the same thing.
 */
export const CONFIRMED_LABEL = "Confirmed";

export const fmtForecastProbability = (p: number | string | null | undefined): string | null => {
    const v = typeof p === "string" ? (p.trim() === "" ? NaN : Number(p)) : p;
    if (typeof v !== "number" || !Number.isFinite(v)) return null;
    if (v >= 1) return CONFIRMED_LABEL;
    return `${Math.min(Math.round(Math.max(v, 0) * 100), 99)}%`;
};
